/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WebhookIndexRouteImport } from './routes/webhook.index'
import { Route as PostsIndexRouteImport } from './routes/posts.index'
import { Route as FeedIndexRouteImport } from './routes/feed.index'
import { Route as AccountsIndexRouteImport } from './routes/accounts.index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WebhookIndexRoute = WebhookIndexRouteImport.update({
  id: '/webhook/',
  path: '/webhook/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostsIndexRoute = PostsIndexRouteImport.update({
  id: '/posts/',
  path: '/posts/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedIndexRoute = FeedIndexRouteImport.update({
  id: '/feed/',
  path: '/feed/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsIndexRoute = AccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accounts/': typeof AccountsIndexRoute
  '/feed/': typeof FeedIndexRoute
  '/posts/': typeof PostsIndexRoute
  '/webhook/': typeof WebhookIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accounts': typeof AccountsIndexRoute
  '/feed': typeof FeedIndexRoute
  '/posts': typeof PostsIndexRoute
  '/webhook': typeof WebhookIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accounts/': typeof AccountsIndexRoute
  '/feed/': typeof FeedIndexRoute
  '/posts/': typeof PostsIndexRoute
  '/webhook/': typeof WebhookIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/accounts/' | '/feed/' | '/posts/' | '/webhook/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/accounts' | '/feed' | '/posts' | '/webhook'
  id: '__root__' | '/' | '/accounts/' | '/feed/' | '/posts/' | '/webhook/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountsIndexRoute: typeof AccountsIndexRoute
  FeedIndexRoute: typeof FeedIndexRoute
  PostsIndexRoute: typeof PostsIndexRoute
  WebhookIndexRoute: typeof WebhookIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webhook/': {
      id: '/webhook/'
      path: '/webhook'
      fullPath: '/webhook/'
      preLoaderRoute: typeof WebhookIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posts/': {
      id: '/posts/'
      path: '/posts'
      fullPath: '/posts/'
      preLoaderRoute: typeof PostsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feed/': {
      id: '/feed/'
      path: '/feed'
      fullPath: '/feed/'
      preLoaderRoute: typeof FeedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts/': {
      id: '/accounts/'
      path: '/accounts'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AccountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountsIndexRoute: AccountsIndexRoute,
  FeedIndexRoute: FeedIndexRoute,
  PostsIndexRoute: PostsIndexRoute,
  WebhookIndexRoute: WebhookIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
